<template>
  <div class="flex flex-col gap-1">

    <div
        class="inline-flex items-center border border-base-300 rounded overflow-hidden bg-base-100 w-[140px] text-sm text-base-content/80">
      <button
          type="button"
          class="w-1/3 py-3 text-center bg-base-200 hover:bg-base-300 disabled:opacity-50"
          :disabled="modelValue <= min"
          @click="update(modelValue - step)"
      >−
      </button>

      <div class="w-2/4 py-3 text-center text-sm select-none bg-white text-medium">
        {{ modelValue }}
      </div>

      <button
          type="button"
          class="w-1/3 py-3 text-center bg-base-200 hover:bg-base-300 disabled:opacity-50"
          :disabled="modelValue >= max"
          @click="update(modelValue + step)"
      >+
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {type: Number, default: 0},
  min: {type: Number, default: 0},
  max: {type: Number, default: Infinity},
  step: {type: Number, default: 1},
  label: {type: String, default: ''}
})

const emit = defineEmits(['update:modelValue'])

function update(val) {
  if (val >= props.min && val <= props.max) {
    emit('update:modelValue', val)
  }
}
</script>